(function() { window.GUID_ead47b54_8cc5_4aff_87b8_5b8c159a1466 = { getGuid: function() { return "ead47b54-8cc5-4aff-87b8-5b8c159a1466"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TopBarSlideOut {
            static Show(params) {
                if (params != null) {
                    if (params.Id != null && params.Id.trim() != "") {
                        CS.Lag("topbarslideout", 50, () => {
                            new TopBarSlideOut(params);
                        });
                    }
                }
            }
            constructor(params) {
                this.show(params);
            }
            show(params) {
                let me = this;
                let $sectionTop = CS.DOM.$body.find(".section-top").last();
                if ($sectionTop.length > 0) {
                    this.$topBarSlideOut = $(TopBarSlideOut.createElement(params));
                    $sectionTop.prepend(this.$topBarSlideOut);
                    this.$topBarSlideOut.offon("click.topbarslideout", (e) => {
                        me.hide();
                    });
                    this.$topBarSlideOut.slideDown(300, () => {
                        setTimeout(() => {
                            me.hide();
                        }, params.AutoHideDuration);
                    });
                }
            }
            hide() {
                let me = this;
                me.$topBarSlideOut.off("click.topbarslideout");
                me.$topBarSlideOut.slideUp(150, () => {
                    me.$topBarSlideOut.remove();
                });
            }
            static createElement(params) {
                let containerCssClass = "topbarslideout-container";
                let contentCssClass = "topbarslideout";
                let txtCssClass = "topbarslideout__txt";
                let closeIconCssClass = "topbarslideout__close-icon icon ic-cs-times";
                const msg = this.decodeHtmlEntities(params.Message);
                //const htmlDecodedMessage = msg.replace(/\/u003c/g, "<").replace(/\/u003e/g, ">").replace(/\/u0027/g, "'");
                return `<div id="${params.Id}" class="${containerCssClass}" style="display:none;">
                        <div class="${contentCssClass}">
                            <div class="${txtCssClass}">${msg}</div>
                            <div class="${closeIconCssClass}"></div>
                        </div>
                    </div>`;
            }
            static decodeHtmlEntities(str) {
                const txt = document.createElement('textarea');
                txt.innerHTML = str;
                return txt.value;
            }
        }
        Controls.TopBarSlideOut = TopBarSlideOut;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=topbarslideout.js.map
